import styled from '@emotion/styled';

const Input = styled.input`
  display: none;
`;

export default {
  Input,
};
